import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import { FeatureDetail } from "@reflag/shared/featureAPI";

export function useFeatureData(featureId?: string | null) {
  const { appId, envId } = useEnvironment();
  return useQuery<FeatureDetail, AxiosError<ErrorResponse>>({
    queryKey: featureQueryKeys.single(appId, envId, featureId!),

    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId">(
          `/apps/${appId}/features/${featureId}`,
          { params: { envId: envId! } },
        )
        .then((res) => res.data.feature),
    enabled: !!appId && !!featureId,
    refetchOnWindowFocus: false,
    retry: false,
  });
}

export function useFeatureKeys() {
  const { appId } = useEnvironment();
  return useQuery({
    queryKey: featureQueryKeys.keys(appId),
    queryFn: () =>
      api
        .get<"/apps/:appId/features/keys">(`/apps/${appId}/features/keys`)
        .then((res) => res.data),
    enabled: !!appId,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
